import { FieldMetaState } from 'react-final-form';

export default (meta: FieldMetaState<unknown>) =>
  meta.touched && !meta.active ? meta.error : undefined;
